<template>
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 16.5H10V22.5H16V21.1667H11.3333V16.5ZM16 11.8333H20.6667V16.5H22V10.5H16V11.8333Z"
      fill="currentColor"
    />
    <rect
      x="0.779597"
      y="1.2796"
      width="30.4408"
      height="30.4408"
      rx="3.2204"
      stroke="currentColor"
      stroke-width="1.55919"
    />
  </svg>
</template>

<script>
export default {
  name: 'ExpandIcon',
}
</script>
